<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_024"><img alt="Image" src="images/f0014-01.jpg"/></a></p><a id="file_024">
<p class="caption">Outside Grumman’s hangar and shop in Valley Stream, New York, “The Plane” awaits another test flight. After a brief round of testing, the XFF-1 was supplied to the navy for $73,975. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_024.vue?f73176c8